<template>
  <v-container>
    <v-card class="pa-0">
      <v-card-title>
        Resource List
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          class="pa-0"
        ></v-text-field>
      </v-card-title>
      <v-divider></v-divider>
      <v-data-table
        dense
        :headers="headers"
        :search="search"
        :items="items.data"
        :server-items-length="items.total"
        :options.sync="pagination"
        :loading="loading"
        item-key="name"
        class="elevation-1"
      >
        <template v-slot:item.file="{item}">
          <v-btn color="grey darken-2 px-2" small dark :href="item.file" target="_blank">
            <v-icon class="pr-2">mdi-image-area</v-icon> View
          </v-btn>
        </template>
        <template v-slot:item.action="{item}">
          <v-btn color="grey darken-2" icon dark @click="confirmDelete(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-btn color="primary" fixed fab bottom right :to="'/vendor/add_resource/'+this.$route.params.vendor_id">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-btn small color="secondary" fixed fab bottom left to="/vendor">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <!-- Delete confirmation -->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-5">
          Are you sure delete?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" text @click="dialog = false">Cancel</v-btn>
          <v-btn color="red darken-4" text @click="deleteItem(resource_data)">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Video play -->
    <v-dialog v-model="preview_data" max-width="400" v-if="show_preview">
      <v-card>
        <v-card-text class="pt-2 rounded-lg px-0">
          <video v-if="preview_data.file_type=='VIDEO'" :src="preview_data.file" width="100%" controls></video>
          <v-img v-if="preview_data.file_type=='IMAGE'" :src="preview_data.file" contain max-height="300px"></v-img>
        </v-card-text>
         <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" text @click="show_preview = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { parseParams, getAlphabets } from "@/plugins/helper";
export default {
  name: "ResourceList",
  data() {
    return {
      vendor_id : null,
      preview_data:null,
      show_preview:false,
      loading: false,
      dialog: false,
      resource_data:{},
      search: "",
      items: {
        current_page: 1,
        per_page: 10,
        data: [],
      },
      headers: [
        { text: "Title", value: "title" },
        { text: "Description", value: "description" },
        { text: "Link/File", value: "file",sortable: false },
        { text: "Action", value: "action", sortable: false },
      ],
      pagination: {
        itemsPerPage: 10,
        sortBy: ["created_at"],
        page: 1,
        filters: {
          item_active: true,
          alphabet: "",
        },
      },
      alphabets: getAlphabets(),
    };
  },
  computed: {
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "title";
      return paginationData;
    },
    getStyles() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return {
          maxWidth: "95%",
          margin: "0 auto",
        };
      } else {
        return {};
      }
    },
  },
  watch: {
    search() {
      this.getItems();
    },
    pagination: {
      handler: function () {
        this.getItems();
      },
      deep: true,
    },
  },
  methods: {
    showPreview(item) {
      this.preview_data = item;
      this.show_preview = true;
    },
    getItems() {
      let _self = this;
      this.loading = "secondary";
      let url = parseParams(this.pageData);
      this.$axios.get("/admin/resource/list?" + url + "&vendor_id="+_self.$route.params.vendor_id)
        .then((response) => {
          _self.items = response.data.data;
          this.loading = false;
        })
        .catch(function () {
          this.loading = false;
        });
    },
    confirmDelete(item){
      this.dialog = true;
      this.resource_data = item;
    },
    deleteItem(item) {
      const index = this.items.data.indexOf(item);
      let _self = this;
      _self.loading = "secondary";
      this.$axios.post("/admin/resource/delete", {
        resource_id: item.resource_id,
      })
      .then((res) => {
        if (res.status) {
          _self.items.data.splice(index, 1);
          _self.dialog = false
        }
        _self.loading = false;
      })
      .catch(function () {
        _self.loading = false;
      });
    },
  },
  mounted(){
    console.log(this.$route.params.vendor_id)
  }
};
</script>